//@ts-check

exports.ENV_VAR_NAME_COOKIE = 'cookiesConsents';

exports.SESSION_VAR_NAME_COOKIE = '_scpb_';

exports.ENV_VAR_NAME_TOS = 'getConsents';


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/GDPR-popups/constants.es.js